import { useContext, useEffect, useState } from 'react';
import './contact.scss';
import { useTranslation } from "react-i18next";
import { RxEnvelopeClosed } from "react-icons/rx";
import { textareaMaxlength, textareaRows } from '../../utils/constants/forms';
import { EmailService } from "../../services/emailService";
import DOMPurify from 'dompurify';
import toast from 'react-hot-toast';
import { LangContext } from '../../providers/LangContext';
import i18n from '../../utils/i18n';
import HeaderInfos from '../commons/headerInfos/headerInfos';
import type { ErrorContactForm } from '../../interfaces/error';
import { LoaderSpinner } from '../commons/loaderSpinner/loaderSpinner';
import ReCAPTCHA from "react-google-recaptcha";

export function Contact(){

    const lang = useContext(LangContext);
    const { t } = useTranslation();
    const [email,setEmail] = useState('');
    const [subject,setSubject] = useState('');
    const [message,setMessage] = useState('');
    const [errors,setErrors] = useState<ErrorContactForm>({});
    const emailService = EmailService();
    const [loading, setLoading] = useState(false);
    const recaptchaKey = import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY;
    const [captchaValue, setCaptchaValue] =useState('')

    if (!recaptchaKey) {
        console.error("RECAPTCHA KEY MISSING");
    }
    
    useEffect(()=>{
        i18n.changeLanguage(lang.lang);
    },[lang]);

    function onChange(value:any) {
        console.log("Captcha value:", value);
        setCaptchaValue(value); 
    }
    function handleChangeEmail(e:any){
        const value = e.target.value;
        const onlyEmailRegExp = new RegExp(/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/);
        const onlyEmail = onlyEmailRegExp.test(value)
        if(onlyEmail){
            setEmail(value);
            setErrors({...errors, mail: ''});
        }else {
            setErrors({...errors, mail:"contact.invalid_email_format"});
        }
    }

    function handleChangeSubject(e: React.ChangeEvent<HTMLSelectElement>){
        const value = DOMPurify.sanitize(e.target.value, {ALLOWED_TAGS: []})

        if (value.trim() !== '') {

            setSubject(value);
            setErrors({ ...errors,subject:''});

        }else{

            setErrors({...errors, subject:"contact.please_specify_request_subject"});
        }
    }

    function handleChangeMessage (e: React.ChangeEvent<HTMLTextAreaElement>){
        const value = DOMPurify.sanitize(e.target.value, {ALLOWED_TAGS: []});
        if (value.trim() !== '') {
            setMessage(value);
            setErrors({...errors, message: ''});
        }else {
            setErrors({...errors, message:  "contact.please_seize_message"});
        }
    }

    function handleSubmit(e: React.FormEvent<HTMLFormElement>){
        e.preventDefault();
        if (!email || !subject || !message) {
            setErrors({
                mail: !email ? "contact.invalid_email_format" : '',
                subject: !subject ? "contact.please_specify_request_subject" : '',
                message: !message ? "contact.please_seize_message" : '',
                captcha: !captchaValue ? "contact.please_set_captcha" : ''
            });
            return;
        }
        setLoading(true);

        const post = {
            service_id: import.meta.env.VITE_EMAIL_LIST_SERVICE_ID,
            template_id: import.meta.env.VITE_EMAIL_LIST_TEMPLATE_ID,
            user_id: import.meta.env.VITE_EMAIL_LIST_API_PUBLIC_KEY,
            template_params: {  
                from_email: email,
                subject: subject,
                message: message,
                'g-recaptcha-response':captchaValue
            } 
        }

        emailService.sendForm(post)
        .then(() => toast(t("contact.message_sent_success")))
        .catch((err) => {
            toast.error(t('contact.mail_send_error'));
            console.error(err);
        }).finally(()=>{
            setLoading(false);
        });
    }

    return (
        <div className='reviews-container content-container'>
            {loading ? (
            <LoaderSpinner visible={true} />
            ) : (
            <>
            
                <HeaderInfos title={t("contact.label")} description={t("contact.description")}/>
                <div>
                    <h1>Contact</h1>
                </div>
                <div className ="contact-container">
                    <aside className='padding'>
                        <div className="contact-infos padding-0-15">
                            <a><RxEnvelopeClosed/> contact@jnicolas.art</a>
                        </div>
                        <div className="contact-rs">
                            
                        </div>
                    </aside>
                    <form className='contact-form padding' onSubmit={handleSubmit} method='post'>
                        <div className='contact-form-body'>
                            <label className='desktop-only'>{t("contact.email")}*</label>
                            <input  required placeholder={t("contact.email")} onChange={(e)=>handleChangeEmail(e)} type="mail" className='form-control'/>
                            <div></div><p className='msg-error'>{errors.mail!=""?t(errors?.mail||''):''}</p>
                            <label>{t("contact.subject")}*</label>
                            <select required className='form-control' onChange = {handleChangeSubject} value={subject}>
                                <option disabled value=""> {t("contact.please_specify_subject")}</option>
                                <option>Webmaster</option>
                                <option>Contacter Josué NICOLAS</option>
                            </select>
                            <div></div><p className='msg-error'>{errors.subject?t(errors.subject ||''):''}</p>
                            <label className='desktop-only'>{t("contact.message")}*</label>
                            <textarea  required placeholder={t("contact.message")} onChange = {handleChangeMessage} className='form-control' rows={textareaRows} maxLength={textareaMaxlength}/>
                            <div></div><p className='msg-error'>{t(errors.message||'')}</p>
                        </div>
                        {Object.values(errors)}
                        <ReCAPTCHA
                        sitekey={recaptchaKey}
                        onChange={onChange}
                        />
                        <div className='contact-form-footer padding-15-0'>
                            <button type='submit' disabled={captchaValue==='' }>{t("contact.submit")}</button>
                            <button type='reset'>{t("contact.reset")}</button>
                        </div>
                    </form>

                </div>
            </>)}
        </div>
    )
}
